import { TransactionType } from '../enums';
export function isJudicialMovement(transaction) {
    return transaction.type === TransactionType.BALANCE_BLOCK || transaction.type === TransactionType.BALANCE_UNLOCK;
}
